import { OwaDate } from 'owa-datetime';
import { AssetId, ProjectId } from 'owa-timestream-types';
import { action } from 'satcheljs';
import { TeachingMomentId } from './schema';

export const focusAsset = action('focusAsset', (projectId: ProjectId, id: AssetId) => ({
    projectId,
    id,
}));

export const navigateCalendarAssetToDate = action(
    'navigateCalendarAssetToDate',
    (date: OwaDate) => ({
        date,
    })
);

export const showTeachingMoment = action(
    'showTeachingMoment',
    (teachingMomentId: TeachingMomentId) => ({
        teachingMomentId,
    })
);
